import React from 'react';
type TXTFileIconPros = {
  width?: string;
  height?: string;
};
function TXTFileIcon({ width = '50', height = '66' }: TXTFileIconPros) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 50 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H33.547L39.9573 5.98291L50 14.7436V57.812C50 62.2302 46.4183 65.812 42 65.812H8C3.58172 65.812 0 62.2302 0 57.812V8Z'
        fill='#EB701F'
      />
      <path
        d='M33.3923 10.5228L33.547 0L50 14.7436L37.3406 14.5813C35.1287 14.5529 33.3597 12.7346 33.3923 10.5228Z'
        fill='#AB4E10'
      />
      <path
        d='M18.736 27.8V29.528H15.456V39H13.616V29.528H10.336V27.8H18.736ZM28.7738 39H26.7098L23.9898 34.632L21.2698 39H19.1898L22.8538 33.128L19.4618 27.8H21.5258L23.9898 31.736L26.4378 27.8H28.4698L25.1098 33.208L28.7738 39ZM37.611 27.8V29.528H34.331V39H32.491V29.528H29.211V27.8H37.611Z'
        fill='white'
      />
    </svg>
  );
}

export default TXTFileIcon;
